import React, { useCallback, useEffect, useReducer, useState } from "react"
import {
    excluirBanner,
    obterBanners,
    salvarBanner,
    uploadBanner,
} from "../../../services/bannerFornecedor"
import useLoadingStore from "../../../stores/LoadingStore"
import { Loading } from "../../RegistradorDePedidos"
import { CadastroBannerFornecedorInicial } from "../models/cadasBannerFornecedorModel"
import { CadastroBannerFornecedorActionsTypes } from "./cadasBannerFornecedorActions"
import { CadasBannerFornecedorContext } from "./CadasBannerFornecedorContext"
import { cadasBannerFornecedorReducer } from "./cadasBannerFornecedorReducer"

export function CadasBannerFornecedorContextProvider({ children }: { children: React.ReactNode }) {
    const [dados, dispatch] = useReducer(
        cadasBannerFornecedorReducer,
        CadastroBannerFornecedorInicial
    )
    const [erroCarregamento, setErroCarregamento] = useState<string | null>(null)
    const setLoading = useLoadingStore(s => s.setLoading)

    const carregar = async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const response = await obterBanners(autorizacao)
            if ("retornoErro" in response) {
                setErroCarregamento(response.mensagem || "Erro ao carregar banners")
            } else {
                setErroCarregamento(null)
                dispatch({ type: CadastroBannerFornecedorActionsTypes.CARREGAR, payload: response })
            }
        } catch {
            setErroCarregamento("Erro ao carregar banners")
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        carregar()
    }, [])

    const upload = useCallback(async (arquivo: File) => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const response = await uploadBanner(autorizacao, arquivo)
            if ("retornoErro" in response) {
                throw new Error(response.mensagem || "Erro ao fazer upload da imagem")
            }
            dispatch({
                type: CadastroBannerFornecedorActionsTypes.SET_URL_BANNER,
                payload: response.url,
            })
        } finally {
            setLoading(false)
        }
    }, [])

    const salvar = useCallback(async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        if (!dados.novoUrlBanner) {
            throw new Error(
                "Você deve primeiro fazer o upload da imagem do banner antes de salvar."
            )
        }
        try {
            setLoading(true)
            const response = await salvarBanner(autorizacao, {
                urlBanner: dados.novoUrlBanner,
                exibirCardapio: dados.novoExibirCardapio,
                exibirTelaInicial: dados.novoExibirTelaInicial,
            })
            if ("retornoErro" in response) {
                throw new Error(response.mensagem || "Erro ao salvar banner")
            }
            dispatch({
                type: CadastroBannerFornecedorActionsTypes.ADICIONAR_BANNER,
                payload: response,
            })
        } finally {
            setLoading(false)
        }
    }, [dados])

    const excluir = useCallback(async (id: number) => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const response = await excluirBanner(autorizacao, id)
            if (response && "retornoErro" in response) {
                throw new Error(response.mensagem || "Erro ao excluir banner")
            }
            dispatch({ type: CadastroBannerFornecedorActionsTypes.REMOVER_BANNER, payload: id })
        } finally {
            setLoading(false)
        }
    }, [])

    return (
        <CadasBannerFornecedorContext.Provider
            value={{ dados, dispatch, salvar, excluir, upload, erroCarregamento }}
        >
            <Loading />
            {children}
        </CadasBannerFornecedorContext.Provider>
    )
}
